module.exports = __webpack_public_path__ + "static/media/gradient.40cb5dad.jpeg";